namespace ui
{
	export namespace Form
	{
		export class Slider
			extends Input<INumberInputDescriptor>
		{
			public constructor( value: number|null, descriptor: INumberInputDescriptor )
			{
				super( 'input', descriptor, 'range', InputValueTypes.NUMBER );

				this.Default	= value;

				this.value( value );
			}

			public Initialize(): void
			{
				super.Initialize();

				if ( this.Descriptor.min !== undefined )
				{
					this.attr( 'min', this.Descriptor.min );
				}
				if ( this.Descriptor.step )
				{
					this.attr( 'step', this.Descriptor.step );
				}
				if ( this.Descriptor.max !== undefined )
				{
					this.attr( 'max', this.Descriptor.max );
				}
			}

			public value( val: number|null ): NumberInput
			{
				// @ts-ignore
				return super.value( val );
			}

			public val(): number
			{
				const val = this.m_Root.val() || this.Descriptor.min;

				return parseInt( val as string, 10 );
			}
		}
	}
}
